var map = {
	"./notice.js": "./mock/controller/notice.js",
	"./router.js": "./mock/controller/router.js",
	"./search.js": "./mock/controller/search.js",
	"./user.js": "./mock/controller/user.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./mock/controller sync recursive \\.js$";